import { useEffect } from "react";
import { LegalLayout, LegalSection } from "./LegalLayout";
import { CONTACT } from "../data/content";

export const Impressum = () => {
    useEffect(() => {
        document.title = "Impressum | Julians Gartenservice";
    }, []);

    return (
        <LegalLayout title="Impressum" eyebrow="Rechtliches" testid="impressum-page">
            <LegalSection title="Angaben gemäß § 5 DDG">
                <p>
                    Julian Kosinski
                    <br />
                    Julian&rsquo;s Gartenservice
                    <br />
                    Gartenpflege &amp; Grundstücksservice
                    <br />
                    Sankt-Georg-Garten 6/3
                    <br />
                    29221 Celle
                    <br />
                    Deutschland
                </p>
            </LegalSection>

            <LegalSection title="Kontakt">
                <p>
                    Telefon:{" "}
                    <a href={CONTACT.phoneHref} className="text-leaf font-medium hover:underline">
                        {CONTACT.phoneDisplay}
                    </a>
                    <br />
                    E-Mail:{" "}
                    <a href={`mailto:${CONTACT.email}`} className="text-leaf font-medium hover:underline">
                        {CONTACT.email}
                    </a>
                </p>
            </LegalSection>

            <LegalSection title="Umsatzsteuer">
                <p>
                    Kleinunternehmer gemäß § 19 UStG. Gemäß § 19 UStG wird keine Umsatzsteuer
                    berechnet und nicht gesondert ausgewiesen.
                </p>
            </LegalSection>

            <LegalSection title="Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV">
                <p>Julian Kosinski, Anschrift wie oben.</p>
            </LegalSection>

            <LegalSection title="Verbraucherstreitbeilegung">
                <p>
                    Ich bin nicht bereit und nicht verpflichtet, an Streitbeilegungsverfahren
                    vor einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
            </LegalSection>
        </LegalLayout>
    );
};
